import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL } from "../actions/helpers";
import axios from "axios";

// Action Types
export const WEALTH_GUIDED_REBALANCES_DELETE = "WGRD/DELETE";
export const WEALTH_GUIDED_REBALANCES_DELETE_SUCCESS = "WGRD/DELETE/SUCCESS";
export const WEALTH_GUIDED_REBALANCES_DELETE_FAILURE = "WGRD/DELETE/FAILURE";

// Action Creators
export const wealthGuidedRebalancesDelete = (uuid) => ({
  type: WEALTH_GUIDED_REBALANCES_DELETE,
  uuid,
});

export const wealthGuidedRebalancesDeleteSuccess = (uuid) => ({
  type: WEALTH_GUIDED_REBALANCES_DELETE_SUCCESS,
  uuid,
});

export const wealthGuidedRebalancesDeleteFailure = (error, uuid) => ({
  type: WEALTH_GUIDED_REBALANCES_DELETE_FAILURE,
  error,
  uuid,
});

// Sagas
function* deleteWealthGuidedRebalances(action) {
  try {
    const { uuid } = action;
    yield axios.delete(`${apiURL}/wealth-series/guided-rebalances/${uuid}`, {
      withCredentials: true,
    });
    yield put(wealthGuidedRebalancesDeleteSuccess(uuid));
  } catch (error) {
    console.error("DELETE guided rebalances failed:", error);
    yield put(wealthGuidedRebalancesDeleteFailure(error));
  }
}

function* listenWealthGuidedRebalancesDelete() {
  yield takeEvery(
    WEALTH_GUIDED_REBALANCES_DELETE,
    deleteWealthGuidedRebalances,
  );
}

// Root Saga
export function* saga() {
  yield all([fork(listenWealthGuidedRebalancesDelete)]);
}

const INIT_STATE = {
  deleting: {},
  error: {},
};

// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case WEALTH_GUIDED_REBALANCES_DELETE:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          [action.uuid]: true,
        },
        error: {
          ...state.error,
          [action.uuid]: null,
        },
      };
    case WEALTH_GUIDED_REBALANCES_DELETE_SUCCESS:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          [action.uuid]: false,
        },
        error: {
          ...state.error,
          [action.uuid]: null,
        },
      };
    case WEALTH_GUIDED_REBALANCES_DELETE_FAILURE:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          [action.uuid]: false,
        },
        error: {
          ...state.error,
          [action.uuid]: action.error,
        },
      };
    default:
      return state;
  }
};

export default reducer;
